import { render, staticRenderFns } from "./PendingAppointment.vue?vue&type=template&id=4ec2f798"
import script from "./PendingAppointment.vue?vue&type=script&lang=js"
export * from "./PendingAppointment.vue?vue&type=script&lang=js"
import style0 from "./PendingAppointment.vue?vue&type=style&index=0&id=4ec2f798&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports